export default "__VITE_ASSET__a1d607fc__"